module.exports = __webpack_public_path__ + "img/LUB00108.981c1a14.png";